module.exports = __webpack_public_path__ + "static/IMG_2596-16340a8d2d9e91e1e7c265f1fe862cff.jpg";